import type { ReactNode } from "react";

export const ToolDetailsPanel = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <div
    role="region"
    aria-label={label}
    className="ml-[26px] mt-[2px] mb-[8px] min-w-0 overflow-hidden rounded-[3.5px] border border-solid border-[#e2e8f0] bg-white"
  >
    {children}
  </div>
);
